import React from 'react';

const ReloadAllAttributesContext = React.createContext({ reload: () => {} });

export default ReloadAllAttributesContext;
